"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'App Event Trigger',
    description: 'Trigger flow when a matching App Event is received',
    isTrigger: true,
});
//# sourceMappingURL=app-event-trigger.js.map